module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "demo-page"
  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('input', {
    staticClass: "btn",
    attrs: {
      "type": "button",
      "value": "开始"
    },
    on: {
      "click": _vm.golist
    }
  })]), _vm._v(" "), _c('div', [_c('input', {
    staticClass: "btn",
    attrs: {
      "type": "button",
      "value": "重置"
    },
    on: {
      "click": _vm.restart
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', {
    staticClass: "title"
  }, [_vm._v("\"古诗词大作战\"")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-19c65d6c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 71
// module chunks = 2